/**************************************************
 * Nombre:       Dialogo_Registro
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Formulario_Datos from "../Formularios/Formulario_Datos";
import {usePasosFormularios} from "../../Modulo_Pasos/Hooks/usePasosFormularios";
import {useState} from "react";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import Formulario_Tipo from "../Formularios/Formulario_Tipo";
import Formulario_Documentos from "../Formularios/Formulario_Documentos";
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import logo from '../../Recursos/logo_redondo.svg'

const Dialogo_Registro = ({datos, cerrar, finalizar}) => {
    const {sCell} = useResponsive()
    const [cargando, setCargando] = useState(false)
    const [datosTraidos, setDatosTraidos] = useState({})
    const {Cargador, Avisos, nuevoAviso, terminar, iniciarCarga} = useCargador({logoRedondo: logo, funcionUno: cerrar})
    const {Pasos, obtenerEntidad} = usePasosFormularios({
        datos: {curso: datos.nombre, justificacion: datos.justificacion, valores: datos.valores},
        formularios: [
            Formulario_Tipo,
            Formulario_Datos,
            Formulario_Documentos
        ]
    })

    const subirDatos = async () => {

        let entidad = await obtenerEntidad();
        /* let doxPdf = await subirPdfHostingFile(entidad.pdf)
         entidad.pdf = doxPdf.data*/
        iniciarCarga('Subiendo Datos')

        let dox = await guardarDoc('potenciales', entidad)
        if (dox.res) {
            terminar({aviso: 'Formulario entregado con exito'})
        } else {
            terminar({aviso: 'Algo fallo, por favor intentalo nuevamente', variante: 'error'})
        }

    }


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Cargador/>

            <Avisos/>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{px: 1, mt: 2}}>
                <Pasos finalizar={subirDatos} cargando={cargando}/>
            </Grid>

        </Grid>
    )

}
export default Dialogo_Registro